export default {
  title: 'Nuova variante',
  fields: {
    product: {
      label: 'Prodotto',
    },
    name: {
      label: 'Nome',
      placeholder: 'Grande',
    },
    price: {
      label: 'Prezzo extra',
    },
  },
  buttons: {
    save: 'Salva',
    close: 'Chiudi',
  },
  toasts: {
    variant_got_created: 'Variante creata',
    variant_got_updated: 'Variante aggiornata',
  },
};
